<template>
  <WrapperTooltipComponent :content="formatStatus">
    <el-tag
      type="default"
      :class="`status ${status} border-radius text-capitalize font-bold`"
    >
      <span v-if="typeStatus == 'short'"> {{ shortCode }}</span>
      <span v-else>{{ formatStatus }}</span></el-tag
    >
  </WrapperTooltipComponent>
</template>

<script>
import WrapperTooltipComponent from "./WrapperTooltip";

export default {
  name: "StatusReadDocumentsComponent",
  computed: {
    formatStatus() {
      switch (this.status) {
        case "draft":
          return "Borrador";
        case "pending":
          return "Pendiente";
        case "preapproved":
          return "Preaprobada";
        case "success":
          return "Aprobada";
        case "nuled":
          return "Anulada";
        case "failed":
          return "Fallida";
        case "partial":
          return "Parcial";
        case "deny":
          return "No aprobada";
        case "timeout":
          return "Timeout";
        default:
          return this.status;
      }
    },
    shortCode() {
      // Códigos cortos explícitos (para evitar colisiones: Pendiente/Parcial/Preaprobada)
      const shortMap = {
        preapproved: "PR",
        partial: "PA",
        pending: "P",
        success: "A",
        draft: "B",
        deny: "N",
        nuled: "AN",
        failed: "F",
        timeout: "T"
      };
      return shortMap[this.status] || this.formatStatus.charAt(0);
    }
  },
  components: {
    WrapperTooltipComponent
  },
  props: {
    status: {
      default: null
    },
    typeStatus: {
      default: "large"
    }
  }
};
</script>

<style lang="scss" scoped></style>
